import { render, staticRenderFns } from "./productfiletable.vue?vue&type=template&id=69aa8d29&scoped=true&"
import script from "./productfiletable.vue?vue&type=script&lang=js&"
export * from "./productfiletable.vue?vue&type=script&lang=js&"
import style0 from "./productfiletable.vue?vue&type=style&index=0&id=69aa8d29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa8d29",
  null
  
)

export default component.exports